export const flexTokenize = "forward"
export const flexId = "id"
export const flexFields = ["title", "terms", "productId", "content"]
